import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ProfileCard, {
  buildStats,
} from "src/components/atoms/ProfileCard/ProfileCard";

import { useViewport } from "src/common/hooks/ViewPort";

import daughterPng from "src/styles/assets/img/icon_red.png";
import husbandPng from "src/styles/assets/img/icon_blue.png";
import Toast from "./components/InfoToast";
import { confirmDialog } from "src/components/containers/ConfirmDialog";
import { PageContainer } from "src/components/organisms/contents";
import { useFamilyRegister } from "src/common/hooks/userFamilyRegister";
import { formatBirthday } from "src/common/hooks/useFormatBirthDay";
import { SubConHeader } from "src/components/atoms/SubHeaderBox/SubConHeader";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { request } from "src/common/api";
import { BaseResponse } from "src/common/types/baseRespones";
import { GET_NOTIFICATION } from "src/common/querykeys";
import { useUserRegister } from "src/common/hooks/useUserRegister";

const FamilyInfoPage: React.FC = () => {
  const queryClient = useQueryClient();
  const navi = useNavigate();
  const { px } = useViewport();

  const [toast, setToast] = useState<string | null>(null);

  // 유저 정보 불러오기
  const { data: userInfo } = useUserRegister();

  // 알림 전송하기
  const { mutateAsync: createNotification } = useMutation({
    mutationFn: (payLoad: any) => {
      return request<BaseResponse>({
        method: "POST",
        url: `/notification/send`,
        data: payLoad,
      });
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: [GET_NOTIFICATION] });
    },
  });

  const handleDisConnect = async (oid: string, name: string) => {
    const isConfirm = await confirmDialog({
      text: `${name} 님과의 연결을 정말로 끊으시겠어요?`,
      title: "가족 연결 끊기",
      options: {
        trueButtonText: "연결 끊기",
        falseButtonText: "유지하기",
      },
    });
    if (isConfirm) {
      const msg = `${name}님과 연결을 끊었어요.`;
      navi("/myinfo", { replace: true, state: { toast: msg } });
    }
  };

  // 가족 정보 불러오기
  const { data: familyInfo } = useFamilyRegister();

  const imgRender = (gender: string) => {
    if (gender === "M") return husbandPng;
    return daughterPng;
  };

  const genderRender = (gender: string) => {
    if (gender === "M") return "남자";
    else return "여자";
  };

  const handleSendAlert = async (payload: any) => {
    await createNotification(payload);
  };

  return (
    <PageContainer isNavBar={true} active="myinfo">
      <>
        {/* 헤더 */}
        <SubConHeader title="가족 정보" onClickArrow={() => navi(-1)} />

        {/* 가족 프로필 리스트 */}
        <main style={{ paddingTop: px(8), paddingBottom: "80px" }}>
          {familyInfo?.map((m) => (
            <ProfileCard
              key={m.oid}
              name={m.userName || ""}
              subinfo={`${m.birthyear}.${formatBirthday(
                m.birthday
              )} | ${genderRender(m.gender || "")}`}
              imgSrc={
                m.profileImage?.startsWith("http")
                  ? m.profileImage
                  : m.profileImage !== "" && m.profileImage !== null
                  ? process.env.REACT_APP_API_FILE! + m.profileImage
                  : imgRender(m.gender || "")
              } // ✅ 변경: img → imgSrc
              stats={buildStats([24, 156, 8])}
              relation="family"
              onDisconnect={() => handleDisConnect(m.oid, m.userName || "")}
              onCheer={() => {
                handleSendAlert({
                  userOid: m.oid,
                  title: "응원 메세지",
                  message: "똑똑, 오늘 루틴은 어때요? 같이 화이팅해봐요!",
                  data: {
                    userName: userInfo?.userName,
                    category: "가족",
                    theme: "응원",
                  },
                });
                setToast(`${m.userName}에게 응원을 보냈어요!`);
              }}
              onCong={() => {
                setToast(`${m.userName}에게 축하를 보냈어요!`);
              }}
              px={px}
            />
          ))}
        </main>

        {/* Toast */}
        <Toast
          message={toast ?? ""}
          open={!!toast}
          px={px}
          onClose={() => setToast(null)}
        />
      </>
    </PageContainer>
  );
};

export default FamilyInfoPage;
